import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "dh"
};
const _hoisted_2 = {
  class: "dh-hero"
};
const _hoisted_3 = {
  class: "dh-hero-text"
};
const _hoisted_4 = {
  class: "dh-h1"
};
const _hoisted_5 = {
  class: "dh-lead"
};
const _hoisted_6 = {
  class: "dh-hero-cta"
};
const _hoisted_7 = {
  class: "dh-section dh-showcase"
};
const _hoisted_8 = {
  class: "dh-h2"
};
const _hoisted_9 = {
  class: "dh-sub"
};
const _hoisted_10 = {
  class: "dh-showcase-row"
};
const _hoisted_11 = {
  class: "dh-showcase-media"
};
const _hoisted_12 = ["alt"];
const _hoisted_13 = {
  class: "dh-showcase-text"
};
const _hoisted_14 = {
  class: "dh-showcase-title"
};
const _hoisted_15 = {
  class: "dh-showcase-desc"
};
const _hoisted_16 = {
  class: "dh-showcase-row dh-reverse"
};
const _hoisted_17 = {
  class: "dh-showcase-media"
};
const _hoisted_18 = ["alt"];
const _hoisted_19 = {
  class: "dh-showcase-text"
};
const _hoisted_20 = {
  class: "dh-showcase-title"
};
const _hoisted_21 = {
  class: "dh-showcase-desc"
};
const _hoisted_22 = {
  class: "dh-showcase-row"
};
const _hoisted_23 = {
  class: "dh-showcase-media"
};
const _hoisted_24 = ["alt"];
const _hoisted_25 = {
  class: "dh-showcase-text"
};
const _hoisted_26 = {
  class: "dh-showcase-title"
};
const _hoisted_27 = {
  class: "dh-showcase-desc"
};
const _hoisted_28 = {
  class: "dh-showcase-cta"
};
const _hoisted_29 = {
  class: "dh-section dh-band"
};
const _hoisted_30 = {
  class: "dh-h2"
};
const _hoisted_31 = {
  class: "dh-sub"
};
const _hoisted_32 = {
  class: "dh-carousel"
};
const _hoisted_33 = {
  class: "dh-speach-card"
};
const _hoisted_34 = {
  class: "dh-speach-media"
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = ["src", "alt"];
const _hoisted_37 = {
  class: "dh-speach-play"
};
const _hoisted_38 = {
  class: "dh-speach-title"
};
const _hoisted_39 = {
  class: "dh-player-frame"
};
const _hoisted_40 = ["src"];
const _hoisted_41 = {
  class: "dh-section"
};
const _hoisted_42 = {
  class: "dh-h2"
};
const _hoisted_43 = {
  class: "dh-grid dh-grid-4"
};
const _hoisted_44 = {
  class: "dh-card-ic"
};
const _hoisted_45 = {
  class: "dh-card-title"
};
const _hoisted_46 = {
  class: "dh-card-desc"
};
const _hoisted_47 = {
  class: "dh-pill"
};
const _hoisted_48 = {
  class: "dh-section"
};
const _hoisted_49 = {
  class: "dh-h2"
};
const _hoisted_50 = {
  class: "dh-whatis-lead"
};
const _hoisted_51 = {
  class: "dh-section"
};
const _hoisted_52 = {
  class: "dh-features-strip"
};
const _hoisted_53 = {
  class: "dh-feat"
};
const _hoisted_54 = {
  class: "dh-feat"
};
const _hoisted_55 = {
  class: "dh-feat"
};
const _hoisted_56 = {
  class: "dh-feat"
};
const _hoisted_57 = {
  class: "dh-cta"
};
const _hoisted_58 = {
  class: "dh-cta-text"
};
const _hoisted_59 = {
  class: "dh-cta-title"
};
const _hoisted_60 = {
  class: "dh-cta-sub"
};
const _hoisted_61 = {
  class: "dh-cta-actions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_icon = _resolveComponent("icon");
  const _component_slide = _resolveComponent("slide");
  const _component_navigation = _resolveComponent("navigation");
  const _component_carousel = _resolveComponent("carousel");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('demoHome.hero.title')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('demoHome.hero.lead')), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_standard_button, {
    onAction: _ctx.goCreator
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('demoHome.cta.uploadFiles')), 1)]),
    _: 1
  }, 8, ["onAction"])])]), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "dh-hero-video"
  }, [_createElementVNode("iframe", {
    src: "https://www.youtube.com/embed/JgoQTLVPBsA",
    title: "Speach",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowfullscreen: ""
  })], -1))]), _createElementVNode("section", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('demoHome.how.title')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('demoHome.how.sub')), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
    src: "/public/images/demo/step1-generator.webp",
    alt: _ctx.$t('demoHome.showcase.step1.title')
  }, null, 8, _hoisted_12)]), _createElementVNode("div", _hoisted_13, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "dh-showcase-num"
  }, "1", -1)), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('demoHome.showcase.step1.title')), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('demoHome.showcase.step1.desc')), 1)])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
    src: "/public/images/demo/step2-style-options.webp",
    alt: _ctx.$t('demoHome.showcase.step2.title')
  }, null, 8, _hoisted_18)]), _createElementVNode("div", _hoisted_19, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "dh-showcase-num"
  }, "2", -1)), _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('demoHome.showcase.step2.title')), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('demoHome.showcase.step2.desc')), 1)])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("img", {
    src: "/public/images/demo/step3-generated-speach.webp",
    alt: _ctx.$t('demoHome.showcase.step3.title')
  }, null, 8, _hoisted_24)]), _createElementVNode("div", _hoisted_25, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "dh-showcase-num"
  }, "3", -1)), _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('demoHome.showcase.step3.title')), 1), _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('demoHome.showcase.step3.desc')), 1)])]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_standard_button, {
    onAction: _ctx.goCreator
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('demoHome.cta.uploadFiles')), 1)]),
    _: 1
  }, 8, ["onAction"])])]), _createElementVNode("section", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('demoHome.examples.title')), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('demoHome.examples.sub')), 1), _createElementVNode("div", _hoisted_32, [_createVNode(_component_carousel, {
    "items-to-show": 1,
    "wrap-around": true,
    mouseDrag: true
  }, {
    addons: _withCtx(() => [_createVNode(_component_navigation)]),
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speaches, s => {
      return _openBlock(), _createBlock(_component_slide, {
        key: s.url
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", {
          class: "dh-speach-thumb",
          onClick: $event => _ctx.openPlayer(s)
        }, [_createElementVNode("img", {
          src: s.thumbnail,
          alt: s.title,
          loading: "lazy"
        }, null, 8, _hoisted_36), _createElementVNode("div", _hoisted_37, [_createVNode(_component_icon, {
          icon: "play"
        })])], 8, _hoisted_35)]), _createElementVNode("div", _hoisted_38, _toDisplayString(s.title), 1)])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })])]), _ctx.playerUrl ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "dh-player-modal",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.closePlayer && _ctx.closePlayer(...args), ["self"]))
  }, [_createElementVNode("button", {
    class: "dh-player-close",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.closePlayer && _ctx.closePlayer(...args)),
    "aria-label": "Close"
  }, [_createVNode(_component_icon, {
    icon: "close"
  })]), _createElementVNode("div", _hoisted_39, [_createElementVNode("iframe", {
    src: _ctx.playerUrl,
    allow: "autoplay; fullscreen; microphone; camera",
    allowfullscreen: ""
  }, null, 8, _hoisted_40)])])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('demoHome.types.title')), 1), _createElementVNode("div", _hoisted_43, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainingTypes, t => {
    return _openBlock(), _createElementBlock("div", {
      class: "dh-card",
      key: t.key
    }, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_icon, {
      icon: t.icon
    }, null, 8, ["icon"])]), _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('demoHome.type.' + t.key + '.title')), 1), _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('demoHome.type.' + t.key + '.desc')), 1), _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('demoHome.type.' + t.key + '.pill')), 1)]);
  }), 128))])]), _createElementVNode("section", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('demoHome.whatis.title')), 1), _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('demoHome.whatis.lead')), 1)]), _createElementVNode("section", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createVNode(_component_icon, {
    icon: "shield-check-outline",
    class: "dh-feat-ic"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('demoHome.feature.security')), 1)]), _createElementVNode("div", _hoisted_54, [_createVNode(_component_icon, {
    icon: "school-outline",
    class: "dh-feat-ic"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('demoHome.feature.lms')), 1)]), _createElementVNode("div", _hoisted_55, [_createVNode(_component_icon, {
    icon: "web",
    class: "dh-feat-ic"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('demoHome.feature.languages')), 1)]), _createElementVNode("div", _hoisted_56, [_createVNode(_component_icon, {
    icon: "account-group-outline",
    class: "dh-feat-ic"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('demoHome.feature.teams')), 1)])])]), _createElementVNode("section", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createVNode(_component_icon, {
    icon: "creation-outline",
    class: "dh-cta-spark"
  }), _createTextVNode(_toDisplayString(_ctx.$t('demoHome.finalCta.title')), 1)]), _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('demoHome.finalCta.sub')), 1)]), _createElementVNode("div", _hoisted_61, [_createVNode(_component_standard_button, {
    onAction: _ctx.goCreator
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('demoHome.cta.uploadFiles')), 1)]),
    _: 1
  }, 8, ["onAction"])])])]);
}